import { render } from "./JobApplication.vue?vue&type=template&id=8ced35b8&scoped=true"
import script from "./JobApplication.vue?vue&type=script&lang=js"
export * from "./JobApplication.vue?vue&type=script&lang=js"

import "./JobApplication.vue?vue&type=style&index=0&id=8ced35b8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ced35b8"]])

export default __exports__